import React from 'react';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Custom
import { closeDialog } from 'actions';
import { dialogShape } from 'constants/PropTypesShapes';
import DialogItem from './DialogItem';

const DialogsManager = ({ dialogsList, handleClose }) => {
  const handleCloseDialog = (dialog) => {
    const componentType = _get(dialog, 'props.component.type');
    // Close immediatly
    // Note: dialog is flushed in actionsChaining middleware
    handleClose(componentType);
  };

  return (
    _map(dialogsList, (dialog, index) => (
      <DialogItem
        key={index}
        dialog={dialog}
        onClose={handleCloseDialog}
      />
    ))
  );
};

DialogsManager.propTypes = {
  dialogsList: PropTypes.arrayOf(dialogShape).isRequired,
  handleClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dialogsList: state.dialog.list,
});

const mapDispatchToProps = (dispatch) => ({
  handleClose: (componentType) => {
    dispatch(closeDialog(componentType));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DialogsManager);



// WEBPACK FOOTER //
// ./components/dialogs/DialogsManager.js